import React from 'react';
import Link from "@amzn/meridian/link";

/**
 * This component will render user alias with link to their phone tool
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PhoneTool = (props) => {
    return (
        <Link target="_blank" href={"https://phonetool.amazon.com/users/" + props.value}>{props.value}@</Link>
    );
}

export default PhoneTool;


// WEBPACK FOOTER //
// ./src/component/common/phoneTool.js